<template>
  <dialog-reset height="75vh" top="5vh" width="80%" title="选择合同" :visible.sync="visible">
    <div>
      <avue-crud v-if="visible" :option="option" :table-loading="loading" :data="data" :page.sync="page" :search.sync="query" :permission="permissionList" :before-open="beforeOpen" v-model="form" ref="crud" @row-update="rowUpdate" @row-save="rowSave"
        @row-del="rowDel" @search-change="searchChange" @search-reset="searchReset" @selection-change="selectionChange" @current-change="currentChange" @size-change="sizeChange" @refresh-change="refreshChange" @row-dblclick="rowDblClick"
        @on-load="onLoad">
      </avue-crud>
    </div>
  </dialog-reset>
</template>
<script>
import crudMixins from "@/mixins/crud-mixins";
import { getContractExtpage } from "../api";

export default {
  mixins: [crudMixins],
  name: 'SelectContract',
  data () {
    return {
      apiConfig: { getList: getContractExtpage },
      defaultParams: {
      },
      visible: false,
      query: {},
      option: {
        cancelHijack: true,
        maxHeight: '380',
        searchShow: true,
        searchSpan: 6,
        searchMenuSpan: 24,
        searchMenuPosition: 'right',
        menu: false,
        calcHeight: 30,
        tip: false,
        border: true,
        index: true,
        addBtn: false,
        viewBtn: true,
        dialogClickModal: false,
        searchLabelWidth: 90,
        indexLabel: '序号',
        align: 'center',
        labelWidth: 135,
        column: [
          {
            label: '合同编号',
            prop: 'contractNo',
            search: true,
          },
          {
            label: '合同名称',
            prop: 'contractName',
            maxlength: 30,
            search: true,
          },
          {
            label: '货主名称',
            prop: 'custNo',
            overHidden: true, // 表格超出隐藏
            search: true, // 查询是否显示
            type: 'select',
            dicUrl: '/api/produce/blade-dept/select/distinct/select', // 接口统一换位这个
            //回显统一配置这个
            props: {
              label: 'deptName',
              value: 'id'
            },
          },
          {
            label: '业务类型',
            prop: 'businessType',
            overHidden: true, // 表格超出隐藏
            type: 'select',
            dataType: 'string',
            dicData: this.$store.getters.commonDict['businessType'],
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '合同约定量(吨)',
            prop: 'contractWeight',
          },
          {
            label: '物资名称',
            prop: 'cargoName',
            required: true,
            type: 'autocomplete-reset',
            typeUse: 'cargoName',

          },
          {
            label: '合同约定量(吨)',
            prop: 'contractWeight',
            type: 'custom-input',
            precision: 2,
            required: true,
          },
          {
            label: '合同入库量(吨)',
            prop: 'inWeight',
            type: 'custom-input',
            add: false,
            edit: false,
          }, {
            label: '合同出库量(吨)',
            prop: 'custom-input',
            type: 'number',
            precision: 2,
            add: false,
            edit: false,
          },
          {
            label: '合同剩余量(吨)',
            prop: 'remainWeight',
            add: false,
            edit: false,
          },
          {
            label: '合同开始日期',
            prop: 'contractStartTime',
            overHidden: true,
            type: 'date',
            valueFormat: 'yyyy-MM-dd',
          },
          {
            label: '合同结束日期',
            prop: 'contractEndTime',
            overHidden: true,
            type: 'date',
            valueFormat: 'yyyy-MM-dd',
          },
        ],
      },
    }
  },
  created () { },
  methods: {
    open (businessType) {
      this.query.businessType = businessType
      this.defaultParams.businessType = businessType
      this.visible = true
    },
    //  提交
    rowDblClick (item) {
      //  带出通知
      this.$emit('replace', item,)
      this.visible = false
    },

  },
}
</script>
<style lang="scss" scoped>
::v-deep .avue-crud__menu {
  display: none;
}
</style>

